enum SemiologyContent {
    ANAMNESIS = 'ANAMNESIS',
    PHYSICAL_EXAM = 'PHYSICAL_EXAM',
    CHANGES = 'CHANGES'
}

export default SemiologyContent;
